"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlToRegexp = exports.compile = exports.parse = exports.tokensToRegexp = void 0;
var tslib_1 = require("tslib");
var p2r = tslib_1.__importStar(require("path-to-regexp"));
var url_1 = require("url");
exports.tokensToRegexp = p2r.tokensToRegexp;
var ESCAPE_PATTERN = /\\/g;
var TOKEN_PATTERN = /:(?!(\/\/))/g;
var ESCAPE_TOKEN = '-e-s-c-';
var TOKEN_TOKEN = '-t-o-k-e-n-';
var ESCAPE_TOKEN_PATTERN = new RegExp(ESCAPE_TOKEN, 'g');
var TOKEN_TOKEN_PATTERN = new RegExp(TOKEN_TOKEN, 'g');
var HASH_NON_CAPTURE_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '?:[#][^/#?]+?',
    modifier: '?'
};
var HASH_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '[#][^/#?]+?',
    modifier: '?'
};
var QUERY_NON_CAPTURE_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '?:[?][^/#?]+?',
    modifier: '?'
};
var QUERY_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '[?][^/#?]+?',
    modifier: '?'
};
var WILDCARD_NON_CAPTURE_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '?:.*',
    modifier: '?'
};
var WILDCARD_TOKEN = {
    name: 0,
    prefix: '',
    suffix: '',
    pattern: '(.*)',
    modifier: '?'
};
var encodeEscape = function (value) {
    return value
        .replace(ESCAPE_PATTERN, ESCAPE_TOKEN)
        .replace(TOKEN_PATTERN, TOKEN_TOKEN);
};
var decodeEscape = function (value) {
    return value.replace(ESCAPE_TOKEN_PATTERN, '\\').replace(TOKEN_TOKEN_PATTERN, ':');
};
var parseEscapedURL = function (url) {
    var components = url_1.parse(encodeEscape(url), false, true);
    return Object.keys(components).reduce(function (components, key) {
        if (typeof components[key] === 'string') {
            components[key] = decodeEscape(components[key]);
        }
        return components;
    }, components);
};
function parse(str, options) {
    var _a = parseEscapedURL(str), auth = _a.auth, hostname = _a.hostname, _b = _a.pathname, pathname = _b === void 0 ? '' : _b, port = _a.port, protocol = _a.protocol, _c = _a.query, query = _c === void 0 ? '' : _c, hash = _a.hash;
    try {
        return tslib_1.__spreadArrays((protocol ? [protocol] : [WILDCARD_NON_CAPTURE_TOKEN]), (hostname
            ? tslib_1.__spreadArrays(['//'], p2r.parse(hostname, options)) : [WILDCARD_NON_CAPTURE_TOKEN]), (auth ? ['@', auth] : []), (port ? [':', port] : []), (pathname
            ? p2r.parse(pathname, options)
            : [WILDCARD_NON_CAPTURE_TOKEN]), (query
            ? tslib_1.__spreadArrays(['?'], p2r.parse(query, options)) : [QUERY_NON_CAPTURE_TOKEN]), (hash ? p2r.parse(hash, options) : [HASH_NON_CAPTURE_TOKEN])).reduce(function (o, entry) {
            var last = o[o.length - 1];
            if (last === WILDCARD_NON_CAPTURE_TOKEN &&
                entry === WILDCARD_NON_CAPTURE_TOKEN) {
                return o;
            }
            if (typeof last === 'string' && typeof entry === 'string') {
                o.pop();
                o.push("" + last + entry);
                return o;
            }
            o.push(entry);
            return o;
        }, []);
    }
    catch (e) {
        e.message = e.message + ": " + str;
        throw e;
    }
}
exports.parse = parse;
function flags(options) {
    return (options === null || options === void 0 ? void 0 : options.sensitive) ? '' : 'i';
}
function compile(str, options) {
    var tokens = parse(str, options).map(function (token) {
        return token === WILDCARD_NON_CAPTURE_TOKEN
            ? WILDCARD_TOKEN
            : token === HASH_NON_CAPTURE_TOKEN
                ? HASH_TOKEN
                : token === QUERY_NON_CAPTURE_TOKEN
                    ? QUERY_TOKEN
                    : token;
    });
    return p2r.tokensToFunction(tokens, options);
}
exports.compile = compile;
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return urlToRegexp(path, keys, options).source; });
    return new RegExp('(?:' + parts.join('|') + ')', flags(options));
}
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) {
        for (var i = 0; i < groups.length; i++) {
            keys.push({
                name: i,
                prefix: '',
                suffix: '',
                modifier: '',
                pattern: ''
            });
        }
    }
    return path;
}
function stringToRegexp(path, keys, options) {
    return exports.tokensToRegexp(parse(path, options), keys, options);
}
function urlToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
exports.urlToRegexp = urlToRegexp;
//# sourceMappingURL=index.js.map